import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { IChatUser } from 'app/interfaces/chatuser.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { ChatService } from 'app/services/chat.service';
import { NotificationsService } from 'app/services/notifications.service';
import { DateTime } from 'luxon';

import { ContactsService } from './../../../../app/services/contacts.service';
import { AppointmentSidebarService } from './../../../appointments/services/appointment-sidebar.service';

export interface ContactTableColumns {
	id;
	displayName;
	email;
	gender;
	refProfessionaId;
	refUserId;
	lastEventDate;
	contactType;
	totalSessions;
	hasPendingPromptuaries;
	status;
}

@Component({
	selector: 'contacts-table',
	templateUrl: './contacts-table.component.html',
	styleUrls: ['./contacts-table.component.scss'],
})
export class ContactsTableComponent {
	public _contacts = [];
	public statusOptions = [
		{ label: this.translateService.instant('CONTACT.NEW'), value: 'new' },
		{ label: this.translateService.instant('CONTACT.ACTIVE'), value: 'active' },
		{
			label: this.translateService.instant('CONTACT.CONCLUDED'),
			value: 'finish',
		},
		{
			label: this.translateService.instant('CONTACT.VACATIONS'),
			value: 'holidays',
		},
		{ label: this.translateService.instant('CONTACT.QUIT'), value: 'quit' },
		{
			label: this.translateService.instant('CONTACT.CONTACT_LATER'),
			value: 'contact_after',
		},
	];

	constructor(
		public router: Router,
		public contactsService: ContactsService,
		public chat: ChatService,
		public atService: ActionTrackerService,
		public appointmentSidebarService: AppointmentSidebarService,
		public notificationsService: NotificationsService,
		public translateService: TranslateService
	) {}

	get contacts(): ContactTableColumns[] {
		return this._contacts;
	}

	@Input() set contacts(value) {
		this._contacts = value;
	}

	@Input() loading = true;
	@Output() onScheduleClick = new EventEmitter<any>();
	@Output() onToggleContact = new EventEmitter<any>();
	formatDate(date) {
		return date ? DateTime.fromISO(date).toFormat('dd/MM/yyyy') : '--';
	}

	onChangeStatus(id, value) {
		this.contactsService
			.patchContact({
				contactIds: [id],
				fieldsToUpdate: {
					status: value?.value,
				},
			})
			.toPromise()
			.then(() => {
				this.atService.eventTracker(
					SCOPE_TYPE.Contact,
					SUBSCOPE_TYPE.List,
					ITEM_TYPE.BtnStatus,
					null,
					{}
				);
				this.notificationsService.showSuccess(
					'',
					this.translateService.instant('CONTACT.STATUS_CHANGED_SUCCESSFULLY')
				);
			});
	}

	public openChat(contact) {
		this.atService.eventTracker(
			SCOPE_TYPE.Contact,
			SUBSCOPE_TYPE.List,
			ITEM_TYPE.BtnChat,
			null,
			{}
		);
		const chatUser: IChatUser = {
			id: contact.refUserId,
			email: contact.email,
			photoUrl: null,
			username: contact.displayName,
			role: this.chat.role,
		};
		this.chat.startConversation(chatUser, 'contacts-table');
	}

	goToProfile(id) {
		this.atService.eventTracker(
			SCOPE_TYPE.Contact,
			SUBSCOPE_TYPE.List,
			ITEM_TYPE.BtnContact,
			null,
			{}
		);
		this.router.navigateByUrl(`/contact/${id}`);
	}

	scheduleAppointment(id) {
		this.atService.eventTracker(
			SCOPE_TYPE.Contact,
			SUBSCOPE_TYPE.List,
			ITEM_TYPE.BtnSchedule,
			null,
			{}
		);
		this.onScheduleClick.emit(id);
	}

	// archiveContact() {
	// 	this.atService.eventTracker(
	// 		SCOPE_TYPE.Contact,
	// 		SUBSCOPE_TYPE.List,
	// 		ITEM_TYPE.BtnArchive,
	// 		null,
	// 		{}
	// 	);
	// }

	editContact(id) {
		this.atService.eventTracker(
			SCOPE_TYPE.Contact,
			SUBSCOPE_TYPE.List,
			ITEM_TYPE.BtnEdit,
			null,
			{}
		);
		this.router.navigateByUrl(`/clients/edit/${id}`);
	}

	isTodayBirthday(date) {
		return (
			DateTime.fromISO(date).toFormat('dd/MM') ===
			DateTime.local().toFormat('dd/MM')
		);
	}
}
